export function DefaultErrorFallback({
  error,
  onRetry,
}: {
  error: Error;
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        padding: "2rem",
        textAlign: "center",
        background: "var(--color-bg)",
        color: "var(--color-text)",
      }}
    >
      <h1 style={{ fontSize: "1.25rem", margin: 0 }}>Something went wrong</h1>
      <p style={{ color: "var(--color-text-secondary)", maxWidth: 480, margin: 0 }}>
        {error.message || "An unexpected error occurred. Try reloading this page."}
      </p>
      <button type="button" className="btn btn-primary" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
